import { createFileRoute, notFound } from '@tanstack/react-router';

import config from '@@config';

import { Isolated } from '../-components/Isolated';

export const Route = createFileRoute('/_authenticated/isolated/{-$scenarioName}/{-$preset}')({
    beforeLoad: () => {
        if (!config.isVisualTest && config.mode !== 'development') {
            throw notFound();
        }
    },
    component: Isolated,
});
